// extracted by mini-css-extract-plugin
export default {"selectOverride":"LangSwitcher_selectOverride__9Co+d","mobileSelect":"LangSwitcher_mobileSelect__ebGE5"};